import { render, staticRenderFns } from "./HomeNavigationControlCtaBtn.vue?vue&type=template&id=71f9220f&scoped=true&"
import script from "./HomeNavigationControlCtaBtn.vue?vue&type=script&lang=js&"
export * from "./HomeNavigationControlCtaBtn.vue?vue&type=script&lang=js&"
import style0 from "./HomeNavigationControlCtaBtn.vue?vue&type=style&index=0&id=71f9220f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f9220f",
  null
  
)

export default component.exports